var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgUnaAmountIcon = function SvgUnaAmountIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#una-amount-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E2D2A",
    d: "M19.25 37.499c-8.284 0-15-7.835-15-17.5s6.716-17.5 15-17.5h2.5v35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E2D2A",
    d: "M6.75 19.999c0 9.665 6.716 17.5 15 17.5s15-7.835 15-17.5-6.716-17.5-15-17.5-15 7.835-15 17.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EB171",
    fillRule: "evenodd",
    d: "M5.5 19.999c0 10.168 7.102 18.75 16.25 18.75S38 30.167 38 19.999s-7.102-18.75-16.25-18.75S5.5 9.831 5.5 19.999m16.25 17.5c-8.284 0-15-7.835-15-17.5s6.716-17.5 15-17.5 15 7.835 15 17.5-6.716 17.5-15 17.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 15,
    fill: "#6EB171",
    rx: 12.5,
    ry: 15,
    transform: "matrix(-1 0 0 1 34.25 4.999)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E2D2A",
    d: "m24.71 9.999-.368 1.366 5.533 4.684v6.096l-11.505 3.31 4.808-.483 3.55 2.728V30l-10.2-3.957v-4.909l4.307-1.923 6.092 2.073-4.526-2.723-3.387-.896-3.121-1.17-1.018-2.916.594-.803 1.549-.186.015-.001 4.107-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EB171",
    fillRule: "evenodd",
    d: "M19.25 39.999h2.5c10.013 0 17.5-9.33 17.5-20s-7.487-20-17.5-20h-2.5c-10.013 0-17.5 9.33-17.5 20s7.487 20 17.5 20m0-2.5h2.5c8.284 0 15-7.835 15-17.5s-6.716-17.5-15-17.5h-2.5c-8.284 0-15 7.835-15 17.5s6.716 17.5 15 17.5",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "una-amount-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h40v40H.5z"
  }))))));
};
export default SvgUnaAmountIcon;